// Libraries
import { Box, Flex } from '@chakra-ui/react';
// Components
import { RootLayout } from '@layout/index';
import { VesselNavbar, VoyageList } from '@organisms/index';
// Utils
// Types
import { VesselPerformanceLayoutProps } from './VesselPerformanceLayout.type';

/**
 * Represents the layout for the vessel performance page.
 *
 * @component
 * @param {VesselPerformanceLayoutProps} props - The props for the vessel performance layout.
 * @param {ReactNode} props.children - The children components to be rendered inside the layout.
 * @returns {ReactElement} The rendered vessel performance layout component.
 */
export const VesselPerformanceLayout = ({ children }: VesselPerformanceLayoutProps) => {
  return (
    <RootLayout>
      <VesselNavbar position='sticky' zIndex='docked' top={{ base: 16, md: 12 }} />
      <Flex flexDirection='column' align='center' rowGap={6}>
        <Flex gap={5} mx='auto' w='full' maxW={310} my={4} px={{ base: 3, md: 6 }}>
          <Box display={{ base: 'none', md: 'block' }} h='calc(100vh - 8rem)'>
            <VoyageList height='full' />
          </Box>
          <Flex direction='column' flex={1} mt={2} gap={5} h='fit-content'>
            {children}
          </Flex>
        </Flex>
      </Flex>
    </RootLayout>
  );
};
